import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Header, Nav, HamburgerMenu } from './components'

import { 
    loginUserCheck, 
    logoutUser,
    userPointFetch
} from '../redux/actions'

class AdminPoint extends Component {

    constructor(){
        super()
        this.state = {
            toggleMenu: false
        }
    }

    componentWillMount() {
        this.props.loginUserCheck()
        this.props.userPointFetch()
    }

    _handleLogout() {
        this.props.logoutUser()
    }

    _handleMenu() {
        this.setState({ toggleMenu: !this.state.toggleMenu })
    }

    showPoints() {
        if(this.props.points) {
            return this.props.points.map((item,index) => {
                let d = new Date(Number(item.userid))
                const date = d.getDate()+"/"+(d.getMonth()+1)+"/"+d.getFullYear()
                return (
                    <tr key={++index}>
                        <td>{index}</td>
                        <td>{item.invoice}</td>
                        <td>{item.type}</td>
                        <td>{item.point}</td>
                        <td>{item.name}</td>
                        <td>{item.remark}</td>
                        <td>{date}</td>
                        <td>{item.created_by}</td>
                    </tr>
                )
            })
        }
    }

    render() { 
        console.log(this.props.points)
        if(!this.props.user) return  <div></div> 
        return (
            <div>
                <Header name={this.props.user} logout={() => this._handleLogout()}/>
                <div className="admin-point">
                    <Nav active="point"/>
                    <div className={(this.state.toggleMenu)? "content moveover": "content"}>
                        <div className="content-inner">
                            <HamburgerMenu onClick={()=>this._handleMenu()} />
                            <div className="title">
                                <h2>คะแนน (Log)</h2>
                            </div>
                            <div className="info">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Invoice</th>
                                            <th>Type</th>
                                            <th>Point</th>
                                            <th>User</th>
                                            <th>Remark</th>
                                            <th>Created Date</th>
                                            <th>Created By</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.showPoints()}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
 
const mapStateToProps = ({ auth, user }) => {

    return { 
        points: user.points,
        user: auth.user,
    }
}
 
export default connect(mapStateToProps, { 
    loginUserCheck, logoutUser, userPointFetch
})(AdminPoint)